import { computed, Ref } from "vue";
import { BoundingBox } from "@/types/stage";

export function useGridGenerator(
  boundingBox: Ref<BoundingBox | null>,
  steps: number,
  lines: number,
  horizontalColor: string,
  verticalColor: string,
  offsetFirstStep = false
) {
  const gridLines = computed(() => {
    if (!boundingBox.value) return [];

    const { minX, minY, maxY, maxX, width, height } = boundingBox.value;

    const stepX = width / steps;
    const stepY = height / steps;

    const startX = minX + (offsetFirstStep ? stepX * -0.5 : 0);
    const startY = minY + (offsetFirstStep ? stepY * -0.5 : 0);

    const verticals = Array.from({ length: lines }, (_, i) => {
      const x = startX + stepX * (i + 1);
      return {
        points: [x, minY, x, maxY],
        stroke: verticalColor,
        strokeWidth: 3,
      };
    });

    const horizontals = Array.from({ length: lines }, (_, i) => {
      const y = startY + stepY * (i + 1);
      return {
        points: [minX, y, maxX, y],
        stroke: horizontalColor,
        strokeWidth: 3,
      };
    });

    return [...verticals, ...horizontals];
  });

  return { gridLines };
}
